// built-in imports
import ReactCountryFlag from "react-country-flag";

// internal imports
import { Select } from "./language-selector.component.styles";
import { useAppContext } from "../../layout/layout";

const LanguageSelector = () => {
  const { lang, setLang } = useAppContext();
  return (
    <Select value={lang} onChange={(e) => setLang(e.target.value)}>
      <option value="en">
        <ReactCountryFlag className="emojiFlag" countryCode="US" />
      </option>
      <option value="de">
        <ReactCountryFlag className="emojiFlag" countryCode="DE" />
      </option>
    </Select>
  );
};
export default LanguageSelector;
